import React from 'react';
import ReactDOM from 'react-dom/client';
// The one and only stylesheet import in the app -- see styles/global.css.
import './styles/global.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
